import React from 'react';

export const ContactPage: React.FC = () => {
    return (
        <div className="page-container">
            <h1>Contact Us</h1>
            <div className="card">
                <p>Have questions or feedback? We'd love to hear from you.</p>
                <div className="contact-info" style={{ marginTop: '1rem' }}>
                    <p><strong>Email:</strong> support@usepolygrid.com</p>
                </div>
            </div>
        </div>
    );
};
